<template>
	<div id="vue_MapSidebar">
		<div class="map_control_section" v-for="section in layers" v-bind:key="section.cid">
			<div class="map_control_header bg-blue">{{ section.name }}</div>
			<div class="map_control_body" style="display: block;">
				<div class="form-group" v-for="layer in section.layers" v-bind:key="layer.layerId">
					<div class="custom-control custom-checkbox">
						<input type="checkbox" class="custom-control-input" v-bind:id="'toggle_' + layer.layerId" v-bind:value="layer.layerId" v-model="activeLayers" />
						<label class="custom-control-label" v-bind:for="'toggle_' + layer.layerId" v-html="layer.name"></label>
					</div>
					<div class="map_control_options" v-if="layer.options && (!layer.options.selectType || layer.options.selectType == 'dropdown') && layer.options.filters && layer.options.filters.length > 0">
						<select class="form-control" v-bind:id="layer.layerId + '_option'" v-on:change="toggleLayerOption(layer.layerId)">
							<option v-for="entry of layer.options.filters" v-bind:key="entry.value" v-bind:value="entry.value" v-bind:selected="!!entry.default">{{ entry.name }}</option>
						</select>
					</div>
					<div class="map_control_options" v-if="layer.sublayers">
						<select class="form-control" v-bind:id="layer.layerId + '_option'" v-on:change="toggleLayerElement(layer.layerId)">
							<option v-for="entry of layer.sublayers" v-bind:key="entry.layerId" v-bind:value="entry.layerId" v-bind:selected="!!entry.default">{{ entry.name }}</option>
						</select>
					</div>
					<div class="map_control_options" v-if="layer.options && layer.options.selectType == 'radio' && layer.options.filters && layer.options.filters.length > 0">
						<div class="custom-control custom-radio" v-for="entry of layer.options" v-bind:key="entry.value" v-bind:value="entry.value">
							<input type="radio" class="custom-control-input" v-bind:name="layer.layerId" v-bind:id="'toggle_' + entry.layerId" v-bind:value="entry.layerId" />
							<label class="custom-control-label" v-bind:for="'toggle_' + entry.layerId">{{ entry.name }}</label>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Request from './Request.js';
import _cloneDeep from 'lodash/cloneDeep';

export default {
	data() {
		return {
			layers: [],
			activeLayers: []
		}
	}, 
	mounted() {
		// Vue component has been created
		this.fetchLayerConfig();
	},
	watch: {
		layers: function() {
			// Layers list has updated (Vue works async)
			window.liveMap._handleLayerList(this.layers);
		},
		activeLayers: function(newArr, oldArr) {
			let layerAdds = newArr.filter(x => !oldArr.includes(x));
			let layerDeletes = oldArr.filter(x => !newArr.includes(x));
			console.log(layerAdds, layerDeletes, newArr);
			for(let l of layerDeletes) {
				if(l in window.liveMap.layerManagers) {
					window.liveMap.layerManagers[l].detachLayer();
				}
			}
			for(let l of layerAdds) {
				if(l in window.liveMap.layerManagers) {
					window.liveMap.layerManagers[l].attachLayer();
				} else {
					console.error('No LayerManager found for: ' + l);
				}
			}
			// Save layer options to localStorage
			// FIXME HACK FOR APP
			if(!($('body').hasClass('androidapp') && oldArr.length === 0) && window.localStorage) {
				window.localStorage.setItem('weatherusa.weatherlive.layers', JSON.stringify(newArr));
			}
		}
	},
	methods: {
		toggleLayerOption(e) {
			var dkey = $('#' + e + '_option').val(); // jq
			if(window.liveMap.layerManagers[e].dataOptions) window.liveMap.layerManagers[e].dataOptions.mVar = dkey;
			window.liveMap.layerManagers[e].refreshLayer();
		},
		toggleLayerElement(e) {
			var dkey = $('#' + e + '_option').val(); // jq
			console.log(e, dkey);
			if(window.liveMap.layerManagers[e]) {
				window.liveMap.layerManagers[e].setElement(dkey);
			}
		},
		fetchLayerConfig() {
			var _self = this;
			new Request({
				url: 'https://www.weatherusa.net/api/v1/feed/map_layers',
				timeout: 15000,
				onSuccess: function(resp) {
					// Array copy
					window.liveMap._layerList = _cloneDeep(resp.body.layers);
					_self.layers = resp.body.layers;
				}
			}).get();
		}
	}
}

</script>
